import React from "react";
import {Link} from "react-router-dom";
import { FaUmbrellaBeach, FaPhoneAlt } from "react-icons/fa";

const Header = () => {
    return (
        <header className="sticky top-0 z-50 border-b border-white/40 bg-white/75 shadow-[0_10px_40px_rgba(15,23,42,0.08)] backdrop-blur-xl">
            <div className="container mx-auto px-4 py-4">
                <div className="flex justify-between items-center">
                    <Link to="/" className="group">
                        <div className="flex items-center gap-3">
                            <div className="rounded-2xl bg-slate-950 p-3 shadow-lg shadow-slate-950/15 transition duration-300 group-hover:-translate-y-0.5 group-hover:shadow-xl group-hover:shadow-slate-950/20">
                                <FaUmbrellaBeach className="text-[#f7c45f] text-2xl" />
                            </div>
                            <div>
                                <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-950">
                                    lava.rent
                                </h1>
                                <p className="text-xs sm:text-sm text-slate-500 font-medium">Lavallette beach stays</p>
                            </div>
                        </div>
                    </Link>
                    
                    <div className="hidden md:flex items-center gap-4">
                        <div className="text-right leading-tight">
                            <p className="text-xs uppercase tracking-[0.18em] text-slate-400">Questions?</p>
                            <a href="tel:412-337-9034" className="inline-flex items-center gap-2 rounded-full bg-slate-950 px-4 py-2 text-sm font-bold text-white transition duration-300 hover:-translate-y-0.5 hover:bg-teal-700">
                                <FaPhoneAlt className="text-xs text-[#f7c45f]" />
                                412-337-9034
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header;
